import React from "react";
import CycloneList from "../../../components/user/standAloneProcess/cycloneResume";
import Layout from "../../../components/layouts/verticalLayout";

const CycloneListPage = (props) => {
  return <Layout body={<CycloneList />} />;
};

CycloneListPage.propTypes = {};

export default CycloneListPage;
